import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Topbar from "../../../components/Topbar";
import Leftbar from "../../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../../components/Loader";
import { showToast } from "../../Utils/utils";

const CreateButton = ({ type = 'user', create }) => {
    const { resourceId, id } = useParams()
    const [loading, setLoading] = useState(false)
    const [showSidebar, setShowSidebar] = useState(false);
    const [label, setLabel] = useState("");
    const [buttontype, setButtonType] = useState("");
    const [value, setValue] = useState("");

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const isFormValid =
        label.trim() &&
        buttontype.trim() &&
        value.trim()


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const body = {
                [type === 'user' ? 'resource_user_id' : 'resource_company_id']: id,
                text: label,
                type: buttontype,
                value,
            };

            const response = await create({ body });
            if (response.status == 200) {
                showToast("Button Created successfully", "success")
                setTimeout(() => {
                    window.location.href = `${type === 'user'
                        ? '/manage-user-button/'
                        : '/manage-company-button/'
                        }${id}`;
                }, [200]);
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.log(error, "error...");
            setLoading(false)
            showToast(error.message, "error")
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to={`/manage-resource/${resourceId}`}><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Manage Resource</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to={`${type === 'user'
                                                                ? '/manage-user/'
                                                                : '/manage-company/'
                                                                }${resourceId}/button/${id}`}><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>{type == 'user' ? 'Agent' : 'Company'}</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Create Button</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <form className="card mb-4" onSubmit={(e) => handleSubmit(e)}>
                                            <div className="card-body">

                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input
                                                        className="form-control"
                                                        value={label}
                                                        onChange={(e) => setLabel(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group d-flex flex-column gap-1 my-2">
                                                    <label>
                                                        Button Type
                                                    </label>
                                                    <select
                                                        className="custom-select-dropdown font-bold"
                                                        value={buttontype}
                                                        onChange={(e) => setButtonType(e.target.value)}
                                                    >
                                                        <option value="" className='option'>Select a Type</option>
                                                        <option value="link" className='option'>Link</option>
                                                        <option value="mail" className='option'>Mail</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Value</label>
                                                    <input
                                                        className="form-control"
                                                        value={value}
                                                        onChange={(e) => setValue(e.target.value)}
                                                    />
                                                </div>

                                                <button type="submit" className="btn cta-btn mt-4" disabled={loading || !isFormValid}>
                                                    Create
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main >
                </div >
            </div >
        </>
    );
};

export default CreateButton;
